import React, { useState, useRef, useEffect } from "react";
import styled from "@emotion/styled";
import Link from "./link";
import TextInputAutofill from "./textBoxAutofill";
import { Colors } from "./colors";
import { useNavigate } from "react-router-dom";
import { mobileWidth } from "./constants";
import LanguageToggle from "./languageToggle";
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import { denormalizeString } from "../util";
import { useCompanies } from "../contexts/CompanyContext";
var rolesData = require('../../roles.json');

const iconAndSearchBarWidth = 50;

const Navbar = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [searchSuggest, setSearchSuggest] = useState([]);
  const [roles, setRoles] = useState([])
  const [searchTerm, setSearchTerm] = useState("");
  const {companies, loading: companiesLoading, companyLogos, companyDisplayNames } = useCompanies();
  const [isLoaded, setIsLoaded] = useState(false);
  const [profileDrop, setProfileDrop] = useState(false);
  const [mobileDrop, setMobileDrop] = useState(false);
  const profileRef = useRef(null);
  const navdropRef = useRef(null);
  const dropRef = useRef(null);
  const pDropRef = useRef(null);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const menu = [ 
    {name : t("navbar_home"), link: '/'},
    {name: t("addsalary_submit"), link: '/addsalary'},
    {name :t("navbar_explore"), link: "/explore"},
    {name : t("navbar_companies"), link: "/companies"},
    {name : t("navbar_about"), link: "/about"},
    // {name : t("navbar_for_employers"), link: "/employers"},
    ]
  const loggedmenu = [
    {name : t("navbar_profile"), link: "/profile"},
    {name : t("navbar_add_salary"), link: "/addsalary"},

  ]

  const fetchRoles = () =>{
    const role_names = []
      for (var i=0; i < rolesData.roles.length; i++){
        role_names.push(denormalizeString(rolesData.roles[i].role_name_en));
        role_names.push(rolesData.roles[i].role_name_ar);
      }

      setRoles(role_names);
  }
  useEffect(() => {
    document.addEventListener("mouseup", handleClickOutside);
    fetch("/api/v1/user/status", { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        setLoggedIn(data.logged_in);
        setIsLoaded(true);
      })
      .catch((error) => console.log(error));

      fetchRoles();

    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  const goToLogin = () => {
    window.location.href = "/login";
  };

  const logoutOnClick = () => {
    fetch(`/logout/`, { method: "POST", credentials: "same-origin" })
      .then((response) => {
        if (response.ok) {
          window.location.href = "/";
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleClickOutside = (event) => {
    if (
      profileRef.current &&
      !profileRef.current.contains(event.target) &&
      !pDropRef.current.contains(event.target) &&
      !event.target.closest(".ProfileWrapper")
    ) {
      setProfileDrop(false);
    }
    if (
      navdropRef.current &&
      !navdropRef.current.contains(event.target) &&
      !dropRef.current.contains(event.target) &&
      !event.target.closest(".ProfileWrapper")
    ) {
      setMobileDrop(false);
    }
  };

  const handleSuggestionClick = (value) => {
    setSearchTerm(value);
    search(value);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      console.log(searchTerm);
      search(searchTerm);
    }
  };

  function search(value){
    setSearchTerm('');
    const lowerValue = value.toLowerCase();
    if (companyDisplayNames.map(str => str.toLowerCase()).includes(lowerValue)) {
      navigate(`/explore?company=${encodeURIComponent(lowerValue)}`);
    }
    console.log(roles)
    if (roles.map(str => str.toLowerCase()).includes(lowerValue)){
      navigate(`/explore?role=${encodeURIComponent(lowerValue)}`);
    }
  };

  const toggleProfile = () => {
    setProfileDrop(!profileDrop);
    if (profileDrop) {
      profileRef.current.focus();
    }
  };

  const toggleDropdown = () => {
    setMobileDrop(!mobileDrop);
    if (mobileDrop) {
      navdropRef.current.focus();
    }
  };

  const searchBarStyle = {
    backgroundColor: "transparent",
    color: Colors.lightGray,
    padding: "none",
    border: "none",
    outline: "none",
    borderRadius: "20px",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
    margin: "3px"
  };

  const listStyle = {
    backgroundColor: Colors.spaceGray,
    width: "95%",
    borderRadius: "6px",
    marginTop: "36px",
    padding: "8px",
  };

  return (
    <NavbarContainer>
      <LogoWrapper href="/">
    <img src="../../static/images/logo.svg" alt="Logo" />
      </LogoWrapper>
      <NavFlexRowStart>
      <SearchBar>
      <SearchIcon/>
      <TextInputAutofill
          style={searchBarStyle}
          dropStyle={listStyle}
          value={searchTerm}
          placeholder={t("navbar_search")}
          suggestionsList={[...companyDisplayNames, ...searchSuggest, ...roles]}
          func={handleSearchChange}
          listFunc={handleSuggestionClick}
          onKeyDown={onKeyDown}
        />
      </SearchBar>
      
      </NavFlexRowStart>
      <DropDownContainer>
        <DropDownIcon onClick={toggleDropdown} ref={dropRef} style={{filter: mobileDrop? "invert(0.3)": "invert(0)"}}>
                  <img src="../../static/images/drop.svg" alt="dropdown" />
        </DropDownIcon>
        <DropDown
        style={{ display: mobileDrop ? "flex" : "none" }}
        onBlur={() => {
          setMobileDrop(false);
        }}
        ref={navdropRef}
      >
        {menu.map((item) => (
          <LinkWrapper key={item.name}>
          <Link linkText={item.name} color="#fff" href={item.link} />
          </LinkWrapper>
        ))}
        <LanguageToggle/>
        {/* {loggedIn?
        <>
        {loggedmenu.map((item) => (
          <LinkWrapper key={item.name}>
          <Link linkText={item.name} color="#fff" href={item.link} />
          </LinkWrapper>
        ))}
        <SignUpButton onClick={logoutOnClick}>{t("navbar_logout")}</SignUpButton>
        </>
      :
      <SignUpButton
              style={{ display: isLoaded && !loggedIn ? "flex" : "none" }}
              onClick={goToLogin}
            >
              {t("navbar_signin")}
      </SignUpButton>
      } */}
      </DropDown>
      </DropDownContainer>
      

      <NavFlexRowEnd>
        {menu.map((item) => (

          <LinkWrapper
          key={item.name}
          onClick={() => {
            navigate(item.link);
          }}
        >
          <span>{item.name}</span>
        </LinkWrapper>

        ))}
        <LanguageToggle/>
        {/* {isLoaded ? (
          <div>
              <ProfileWrapper onClick={toggleProfile} ref={pDropRef} style={{ display: loggedIn ? "flex" : "none"}}>
                <img src="../../static/images/profile.svg" alt="dropdown" />
              </ProfileWrapper>
            <SignUpButton
              style={{ display: isLoaded && !loggedIn ? "flex" : "none" }}
              onClick={goToLogin}
            >
              {t("navbar_signin")}
            </SignUpButton>
          </div>
        ) : (
          <LinkWrapper style={{ width: "50px", height: "60px" }}></LinkWrapper>
        )} */}
              

      </NavFlexRowEnd>

      
      <DropDown
        style={{ display: profileDrop ? "flex" : "none", insetInlineEnd:"1%" }}
        onBlur={() => {
          setProfileDrop(false);
        }}
        ref={profileRef}
      >
        {loggedmenu.map((item) => (
          <LinkWrapper key={item.name}>
          <Link linkText={item.name} color="#fff" href={item.link} />
          </LinkWrapper>
        ))}
        <SignUpButton onClick={logoutOnClick}>{t("navbar_logout")}</SignUpButton>
      </DropDown>

      
    </NavbarContainer>
  );
};

export default Navbar;

const SearchBar = styled.div`
  color:${Colors.lightGray};
  background-color:${Colors.lightSpaceGray};
  display:flex;
  flex-direction:row;
  align-items: center;
  height:fit-content;
  width:100%;
  border-radius: 20px;
  padding:0 10px;
`

const DropDownContainer = styled.div`
  display:flex;
  flex-direction:row;


`
const DropDown = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 65%;
  background: ${Colors.spaceGray};
  border: 2px solid ${Colors.lightSpaceGray};
  border-radius: 8px;
  padding-bottom: 8px;
  gap: 12px;
  padding: 8px;
  padding-bottom: 8px;
  align-items: center;
  inset-inline-end: 8%;
`;
const NavbarContainer = styled.div`
  font-size:20px;
  position: fixed;
  top: 0;
  left: 0;
  width: 96vw;
  height: 100px;
  background-color: ${Colors.spaceGray};
  color: ${Colors.lightGray};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  z-index: 1000;
  padding: 0 2vw; /* Adjusted padding */
`;

const LogoWrapper = styled.a`
  height: 45px;
  width: 65px;
  padding: 8px;
  cursor: pointer;
  display: flex;
`;

const NavFlexRowStart = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: ${iconAndSearchBarWidth}%;
`;

const NavFlexRowEnd = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: ${100 - iconAndSearchBarWidth}%;
  margin-left: 12px;
  @media (max-width : ${mobileWidth}) {
    display:none;
  }
`;

const LinkWrapper = styled.div`
  text-align: center;
  display: inline-block;
  padding: 8px;
  border-radius: 8px;
  background-color: ${Colors.spaceGray}; /* Change to your preferred background color */
  color: #fff; /* Change to your preferred text color */
  text-decoration: none;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s;

  &:hover {
    background-color: ${Colors.charcolGrey}; /* Change to your preferred hover background color */
    color: #fff; /* Change to your preferred hover text color */
  }
`;

const SignUpButton = styled.button`
  font-size: inherit;
  background-color: ${Colors.strangegreen};
  color: ${Colors.white};
  padding: 10px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
  &:hover {
    background-color: ${Colors.darkstrangegreen};
  }

  &:active {
    background-color: ${Colors.brightstrangegreen};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.5);
  }
`;
const ProfileWrapper = styled(LogoWrapper)`
  filter: invert(1);
  margin: 8px;
  width: 24px;
  height: 24px;
  border: 1px solid black;
  border-radius: 50px;
  border-width: 3px 3px 0 3px;
  &:hover {
    filter: invert(0.5);
  }
  &:active {
    filter: invert(0.3);
  }

  @media (max-width :  ${mobileWidth}){
    display: none;
  }
`;

const DropDownIcon = styled(LogoWrapper)`
  width: 45px;
  height: 45px;
  display: none;
  &:hover {
    filter: invert(0.5);
  }
  &:active {
    filter: invert(0.3);
  }
  @media (max-width : ${mobileWidth}){
    display: flex;
  }
`